/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetWorkflowRunResponse,
  GetWorkflowRunTreeSurveyResponse,
  GetWorkflowRunsParams,
  GetWorkflowRunsResponse,
  RetryWorkflowRunResponse
} from '../model';

import getWorkflowRunsMutator from '../../../mutators/datastore-instance';
import getWorkflowRunMutator from '../../../mutators/datastore-instance';
import getWorkflowRunTreeSurveyMutator from '../../../mutators/datastore-instance';
import postWorkflowRunRetryMutator from '../../../mutators/datastore-instance';



  /**
 * WorkflowRunの一覧・検索をする
 * @summary WorkflowRunの一覧・検索
 */
export const getWorkflowRuns = (
    params?: GetWorkflowRunsParams,
 ) => {
      return getWorkflowRunsMutator<GetWorkflowRunsResponse>(
      {url: `/workflow-runs`, method: 'GET',
        params
    },
      );
    }
  /**
 * WorkflowRunの詳細取得をする
 * @summary Workflowの詳細取得
 */
export const getWorkflowRun = (
    workflowRunId: number,
 ) => {
      return getWorkflowRunMutator<GetWorkflowRunResponse>(
      {url: `/workflow-runs/${workflowRunId}`, method: 'GET'
    },
      );
    }
  /**
 * WorkflowRun の AI 毎木調査（PGC Forest）の結果を返す。
 * 結果を持つ job が run 内に複数あるときは、`workflow_job_id` が最大の job の結果を返す。
 * 記録は job の終端より前に行うため、`status_id` が succeeded 以外の結果は確定していないか再実行前の古い値でありうる。呼び出し側は succeeded のときだけ使う。
 * 404: WorkflowRun が無い（他組織を含む）、または結果がまだ記録されていない
 * @summary WorkflowRun の AI 毎木調査結果の取得
 */
export const getWorkflowRunTreeSurvey = (
    workflowRunId: number,
 ) => {
      return getWorkflowRunTreeSurveyMutator<GetWorkflowRunTreeSurveyResponse>(
      {url: `/workflow-runs/${workflowRunId}/tree-survey`, method: 'GET'
    },
      );
    }
  /**
 * WorkflowRunを再実行する
 * @summary WorkflowRunの再実行
 */
export const postWorkflowRunRetry = (
    workflowRunId: number,
 ) => {
      return postWorkflowRunRetryMutator<RetryWorkflowRunResponse>(
      {url: `/workflow-runs/${workflowRunId}/retry`, method: 'POST'
    },
      );
    }
  export type GetWorkflowRunsResult = NonNullable<Awaited<ReturnType<typeof getWorkflowRuns>>>
export type GetWorkflowRunResult = NonNullable<Awaited<ReturnType<typeof getWorkflowRun>>>
export type GetWorkflowRunTreeSurveyResult = NonNullable<Awaited<ReturnType<typeof getWorkflowRunTreeSurvey>>>
export type PostWorkflowRunRetryResult = NonNullable<Awaited<ReturnType<typeof postWorkflowRunRetry>>>
